import { render, staticRenderFns } from "./Reklamationsstatus.vue?vue&type=template&id=f97c9728&scoped=true&"
import script from "./Reklamationsstatus.vue?vue&type=script&lang=js&"
export * from "./Reklamationsstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97c9728",
  null
  
)

export default component.exports